export const kgToLb = (kg) => 2.20462262 * kg;
export const lbToKg = (lb) => lb * 0.453592;
